import { changePassword } from '@plug-core/handlers/walletActions/wallet'
import { logger } from '@plug-core/logger'
import { Button, Field, Input } from '@ui'
import { ROUTES } from '@utils/routes'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { SetupStep } from './SetupStep'

export const WalletSetupPassword = () => {
  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [repeatedPasswordError, setRepeatedPasswordError] = useState('')

  const { t } = useTranslation()
  const navigate = useNavigate()

  const onNextClick = useCallback(async () => {
    let passwordError = ''
    let repeatedPasswordError = ''

    if (password.length < 8) {
      passwordError = t('passwordSetup.passwordError')
      setPasswordError(passwordError)
    } else {
      setPasswordError(passwordError)
    }

    if (repeatPassword !== password) {
      repeatedPasswordError = t('passwordSetup.repeatedPasswordError')
      setRepeatedPasswordError(repeatedPasswordError)
    } else {
      setRepeatedPasswordError(repeatedPasswordError)
    }

    if (!passwordError && !repeatedPasswordError) {
      try {
        await changePassword(password)
        navigate(ROUTES.ROOT)
      } catch (e) {
        logger.error('Unable to set password', { originalError: e })
      }
    }
  }, [password, repeatPassword])

  return (
    <SetupStep title={t('passwordSetup.title')} description={t('passwordSetup.description')}>
      <div className="flex flex-col gap-4">
        <Field label={t('passwordSetup.password')} error={passwordError || undefined}>
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />
        </Field>

        <Field label={t('passwordSetup.repeatPassword')} error={repeatedPasswordError || undefined}>
          <Input
            type="password"
            value={repeatPassword}
            onChange={(e) => setRepeatPassword(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && onNextClick()}
          />
        </Field>

        <Button
          variant="primary"
          disabled={password.length === 0}
          onClick={onNextClick}
          fullWidth
          className="mt-2"
        >
          {t('passwordSetup.set')}
        </Button>
      </div>
    </SetupStep>
  )
}
